<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429932950_toc01#toctitle3" id="title3"><span><strong class="b">Part One</strong></span></a></div>
<div class="subtitle-part"><strong class="b"><em class="i">The Seven Motivations for Espionage</em></strong></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429932950_p01.vue?40d870ee